module.exports = __webpack_public_path__ + "img/Sec02L2.7e37f21c.jpg";